<template>
  <PanelRow v-if="getData">
    <Panel class="newcontest">
      <p class="main-title mb-3">Bounty Detail</p>

      <div class="" v-if="first_name">
        <table class="table compaign-form details-form">
          
          <tbody>
            <tr>
              <th scope="row">Task ID :</th>
              <td>{{ task_id }}</td>
            </tr>
            <tr>
              <th scope="row">User Name :</th>
              <td>{{ first_name }} {{ last_name }}</td>
            </tr>

            <tr>
              <th scope="row">User Email ID :</th>
              <td>{{ email }}</td>
            </tr>

            <tr>
              <th scope="row">Company Name :</th>
              <td>{{ company_name }}</td>
            </tr>

            <tr>
              <th scope="row">Company Email ID :</th>
              <td>{{ company_email }}</td>
            </tr>

            <tr>
              <th scope="row">Request date :</th>
              <td>{{ date | formatDate }}</td>
            </tr>

            <tr>
              <th scope="row">Project :</th>
              <td>{{ project }}</td>
            </tr>

            <tr>
              <th scope="row">Project Description :</th>
              <td>{{ project_description }}</td>
            </tr>

            <tr>
              <th scope="row">Campaign :</th>
              <td>{{ compaign }}</td>
            </tr>

            <tr>
              <th scope="row">Bounty Type :</th>
              <td>{{ bounty_type }}</td>
            </tr>

            <tr>
              <th scope="row">Campaign Description :</th>
              <td>{{ compaign_description }}</td>
            </tr>

            <tr>
              <th scope="row">Start Date :</th>
              <td>{{ start_date | formatDate }}</td>
            </tr>

            <tr>
              <th scope="row">End Date :</th>
              <td>{{ end_date | formatDate }}</td>
            </tr>

            <tr>
              <th scope="row">Paid Amount :</th>
              <td>{{ totalPaid }} {{ tokenTicker }}</td>
            </tr>
            
          </tbody>
        </table>

        <div class="details-form">
          <div class="m-textbox">
            <label for="exampleInputEmail1">Status: </label>
            <select
              class="custom-select"
              v-model="selStatus"
              name="selStatus"
              id="selStatus"
            >
              <option value="Published">Published</option>
              <option value="Unpublished">Unpublished</option>
            </select>
          </div>
        </div>
        <div class="half-width-textbox">
          <button type="button" class="save-btn" id="submitData" @click="submitData">
            Save Changes
          </button>
        </div>
      </div>

      <div class="briefinfo" v-else>
        <div class="timeline csmt-width">
          <p class="over-timeline-title">No data found</p>
        </div>
      </div>
    </Panel>
  </PanelRow>
  <Loading v-else />
</template>

<script>
import List from '@/helpers/components/display/List'
import Wizard from '@/helpers/components/display/Wizard'
import Recordset from '@/providers/api/Recordset'
import ModalDialogs from 'vue-modal-dialogs'
import {list as mixin} from '@/helpers/mixins/pagination'
import form from '@/helpers/mixins/form'
import {reports as fields} from '@/apps/loyaltyvenue/fields'
import {format as dateformat, getDaysInMonth} from 'date-fns'
import _ from 'lodash'
import Vue from "vue";
import VueAlertify from "vue-alertify";
import { VTooltip, VPopover, VClosePopover } from "v-tooltip";
import moment from "moment";
import Nl2br from "vue-nl2br";

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("DD.MM.YYYY");
  }
});
Vue.filter("formatDateTimer", function (value) {
  if (value) {
    return moment(String(value)).format("DD.MM.YYYY HH:mm");
  }
});
Vue.directive("tooltip", VTooltip);
Vue.directive("close-popover", VClosePopover);
Vue.component("v-popover", VPopover);
Vue.use(VueAlertify, {
  notifier: {
    delay: 3,
    position: "top-right",
    closeButton: false,
  },
});
Vue.component("nl2br", Nl2br);


export default {
  name: "BountyDetail",
  mixins: [mixin],
  props: {
    contest: { required: false },
  },
  data() {
    return {
      alertMsg: "",
      getData: false,
      task_id: "",
      first_name: "",
      last_name: "",
      email: "",
      company_name: "",
      date: "",
      project: "",
      project_description: "",
      compaign: "",
      compaign_description: "",
      start_date: "",
      end_date: "",
      bounty_type: "",
      company_email: "",
      selStatus: "Unpublished",
      compaign_id: "",
      totalPaid: 0,
      tokenTicker: '',
    };
  },
  methods: {
    submitData: function (e) {
      e.preventDefault();
      
      document.getElementById("submitData").disabled = true;
      document.getElementById("submitData").innerHTML = "Processing...";
      this.api
        .post(
          "/sso/aquest/master/updateBountyStatusBYAdmin",
          {
            compaign_id: this.compaign_id,
            status: this.selStatus
          },
          { "app-token": "6e837457fd14dd0a05d8" }
        )
        .then((response) => {
          if (response.status == 200) {
            this.$alertify.success(response.message);
            this.$router.push({ name: 'admin.bountylist' });
          } else {
            this.$alertify.error(response.message);
          }
          document.getElementById("submitData").disabled = false;
          document.getElementById("submitData").innerHTML = "Save Changes";
        })
        .catch((error) => {
          document.getElementById("submitData").disabled = false;
          document.getElementById("submitData").innerHTML = "Save Changes";
          this.$alertify.error(error);
        });
    },
  },
  created() {
    var compaign_id = this.$route.params.compaign_id;

    if(compaign_id == '' || compaign_id == undefined)
    this.$router.push({ name: 'admin.bountylist' });
    else {
      this.compaign_id = compaign_id;

      this.api
        .post(
          "/sso/aquest/master/getCompaignDetailForAdmin",
          {
            compaign_id: compaign_id
          },
          { "app-token": "6e837457fd14dd0a05d8" }
        )
        .then((response) => {
          if (response.status == 200 && response.data.length > 0) {
            response = response.data[0];
            this.getData = true;

            this.task_id = response.id;
            this.company_name = response.apptokens_company_name;
            this.company_email = response.apptokens_company_contact_email;
            this.first_name = response.users_f_name;
            this.last_name = response.users_l_name;
            this.email = response.users_email;
            this.date = response.created_at;
            this.selStatus = response.publish;
            this.project = response.project_title;
            this.project_description = response.project_description;
            this.compaign = response.title;
            this.compaign_description = response.description;
            this.start_date = response.start_date;
            this.end_date = response.end_date;
            this.bounty_type = response.bounty_type_name;
            this.totalPaid = response.max_submission_accepted * response.max_reward_per_submission;
            this.tokenTicker = response.token_ticker;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
};
</script>

<style>
@import "../../assets/css/style.css";
</style>

<style lang="scss">
@import "../../assets/scss/variables";

.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    width: 500px;
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }

  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
}
</style>


// WEBPACK FOOTER //
// src/sections/general/BountyDetail.vue